import React from 'react'

export interface FlashMessage {
  type: 'success' | 'danger'
  text: string
}

interface Props {
  flash: FlashMessage | null
  onDismiss: () => void
}

const Flash = ({ flash, onDismiss }: Props) => {
  if (!flash) return null

  return (
    <div className={`alert alert-${flash.type} d-flex justify-content-between`} role="alert">
      <span>{flash.text}</span>
      <button type="button" className="btn-close" onClick={onDismiss} aria-label="Close" />
    </div>
  )
}

export default Flash
